import React, {Component, useLayoutEffect} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import SvgIcon from 'react-icons-kit';
import {priceTag} from 'react-icons-kit/icomoon/priceTag';
import moment from 'moment';
import { functionalCriterial, healthFacilities, htmlTemplates, printLabel, unitAsociationId, unitRequest } from '../../libs/services';

var Config = require('../../config');

class ModalView extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.labelPrint = this.labelPrint.bind(this);

		this.state = {
			show: false,
			requested_by:"",
			req_by:"",
			requested_to:"",
			req_to:"",
			messenger:"",
			observations:"",
			hour:"",
			date_form:"",
			priority:"",
			unitsSolicited:[],
			unitsAsociation:[],
			user:"",
			user_receive:"",
			preview_print:{},
			id:"",
			show_label_btn:true,
		}
	}

	async componentDidMount(){
		this.props.onRef(this);

		var response = await functionalCriterial('lab_preview_print');
		if(response){
			this.setState({
				preview_print: response
			});
		}
	}

	async handleShow(title, id){
		var response = await unitRequest(id, this.props.waiting);
		if(response !== undefined){
			var date = new Date(response.date);

			this.setState({
				user :  response.user_send,
				requested_by:response.distribuidor,
				requested_to:response.receptor_name,
				  messenger: response.messenger,
				  //observations: response.unit_request.observaciones,
				  hour:response.hour,
				  date_form : date.getFullYear()+'-'+("0" + (date.getMonth() + 1)).slice(-2)+'-'+("0" + date.getDate()).slice(-2),
				  priority: response.priority.indexOf('HORAS') !== -1 ? '24 Horas' : 'Urgente',
				  unitsSolicited:response.detail,
				  //unitsAsociation:response.units_asociation,
				user_receive:response.user_receive,
				  show: true,
				title: title,
				id: id,
				show_label_btn: response.distribuidor_id.toString() !== sessionStorage.getItem('health_facilities_id')
			});

			this.getHealthFacilities();
		}

		response = await unitAsociationId(id);
		if(response !== undefined){
			this.setState({ 
				unitsAsociation: response
			});
			
		}
	}

	async getHealthFacilities(){
		//traer hospitales
		var response = await healthFacilities();
		if(response){
			for (var i = 0; i < response.length; i++) {
				if (response[i].name === this.state.requested_by) {
					this.setState({req_by:response[i].name});

				}else if(response[i].name === this.state.requested_to){
					this.setState({req_to:response[i].name});
				}
			}
		}
	}

	handleClose(){
		this.setState({
			show: false,
			requested_by:"",
			req_by:"",
			requested_to:"",
			req_to:"",
			messenger:"",
			observations:"",
			hour:"",
			date_form:"",
			priority:"",
			unitsSolicited:[],
			unitsAsociation:[],
			user:"",
			user_receive:"",
			id:"",
			show_label_btn:true,
		});
	}

	async labelPrint(e, id){
		e.preventDefault();
		
		var response = htmlTemplates(sessionStorage.getItem("health_facilities_id"), 'label_entry_hemored');
		if(response){
			if(response.res === 0){
				swal('¡Error!', "No se ha definido ninguna etiqueta", 'error');
			}else{
				this.props.waiting.handleShow('Imprimiendo...');
				
				var obj ={};
				obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
				obj.id = id;
				obj.file_type = "label_entry_hemored";
				obj.nEtiqueta = [0];

				response = await printLabel(obj);
				if(response !== undefined){
					if(this.state.preview_print.value === "NO"){
						//PREVIEW
						var fileURL = URL.createObjectURL(response);
						window.open(fileURL);
					}else{
						//PRINTER
						var reader = new FileReader();
						reader.readAsDataURL(response); 
						reader.onloadend = ()=>{
							var base64data = reader.result;  
							var aux = base64data.split(',');
							this.props.socket.send('{"Operacion":"print", "Type":"label_entry_hemored", "File": "'+aux[1]+'"}');
						}
					}
				}

				this.props.waiting.handleClose();
			}
		}
	}

	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{this.state.title}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Centro Distribuidor</span>
		        				<input type="text" className="form-control" value={this.state.req_by} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Centro Peticionario</span>
		        				<input type="text" className="form-control" value={this.state.req_to} disabled/>
		        			</div>

		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Fecha</span>
		        				<input type="date" className="form-control" value={this.state.date_form} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Hora</span>
		        				<input type="text" className="form-control" value={this.state.hour} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Prioridad</span>
		        				<input type="text" className="form-control" value={this.state.priority} disabled/>
		        			</div>

		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Usuario Solicita</span>
		        				<input type="text" className="form-control" value={this.state.user} disabled/>
		        			</div>
							<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Usuario Recibe</span>
		        				<input type="text" className="form-control" value={this.state.user_receive} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Mensajero</span>
		        				<input type="text" className="form-control" value={this.state.messenger || ""} disabled/>
		        			</div>

		        			{/*<div className="col-xs-12">
		        				<span className="span-min">Observaciones</span>
		        				<textarea className="form-control" value={this.state.observations} disabled></textarea>
		        			</div>*/}
		        		</div>
		        		<div className="col-xs-12">
		        			<fieldset>
			        			<legend>Unidades Solicitadas</legend>
			        			<Table responsive hover>
			        				<thead>
					                  	<tr>
						                    <th>Componente Sanguineo</th>
						                    <th>Cantidad</th>
						                    <th>Grupo y RH</th>
						                    <th>Observaciones</th>
					                  	</tr>
					                </thead>
					                <tbody>
					                 	{this.state.unitsSolicited.map( (unit, index) => (
					                    	<tr key={index}>
					                      		<td>{unit.component}</td>
						                      	<td>{unit.amount}</td>
						                      	<td>
						                      		{unit.group+
						                      		(unit.rh === 'POSITIVO' ? '+' : unit.rh === 'NEGATIVO' ? '-' : unit.rh)} 
						                      	</td>
						                      	<td>{unit.observations}</td>
					                    	</tr>
					                  	))}
					                </tbody>
			        			</Table>
			        		</fieldset>

			        		{this.state.unitsAsociation.length > 0 ?
			        			<fieldset>
				        			<legend>
				        				{this.state.req_to === sessionStorage.getItem('health_facilities_name') ?
				        					'Unidades Recibidas'
				        				: 'Unidades Enviadas'}
				        			</legend>
				        			<Table responsive hover>
				        				<thead>
						                  	<tr>
						                  		<th>No. Unidad</th>
							                    <th>Componente Sanguíneo</th>
							                    <th>No. Componente</th>
							                    <th>Caducidad</th>
							                    <th>Volumen</th>
												<th></th>
						                  	</tr>
						                </thead>
						                <tbody>
						                	{this.state.unitsAsociation.map((u, i)=>{
						                		return <tr key={i}>
						                			<td>{u.unit.unit_number}</td>
							                      	<td>{u.blood_component.component}</td>
							                      	<td>{u.unit.component_number}</td>
							                      	<td>{moment(u.unit.caducidad).format('DD/MM/YYYY')} </td>
							                      	<td>{u.unit.volume} ml</td>
													<td>
														{this.state.show_label_btn &&
															<FloatingActionButton backgroundColor={'#ededed'} iconStyle={{height: 33, width: 33}} 
																title="Etiqueta" mini={true} style={{marginLeft:"5px"}} 
																onClick={(e)=>this.labelPrint(e, u.units_asociation.id)}	
															>
																<SvgIcon icon={priceTag} className="icon-align"/>
															</FloatingActionButton>
														}
													</td>
						                		</tr>
						                	})}
						                </tbody>
				        			</Table>
				        		</fieldset>
			        		: null}
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>

		)
	}

} 

export default translate('translations') (ModalView);